import Colors from 'assets/Colors';
import Styles from 'assets/Styles';
import BaseButton from 'common/components/bases/BaseButton';
import BaseText from 'common/components/bases/BaseText';
import UIConst from 'consts/UIConst';
import React from 'react';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import AntDesign from 'react-native-vector-icons/AntDesign';

export default ({ disabled, style, onPress, onClick, icon, text, textStyle, children, color = Colors.colorApp, iconSize = UIConst.SCALE * 18, textProps = {} }) => {
  if (typeof icon === 'string') {
    if (icon === 'add') icon = <MaterialIcons name={'add-circle'} size={iconSize} />;
    else if (icon === 'add1') icon = <MaterialIcons name={'add-circle-outline'} size={iconSize} />;
    else if (icon === 'barcode') icon = <MaterialCommunityIcons name={'barcode-scan'} size={iconSize} />;
    else if (icon === 'search') icon = <MaterialIcons name={'search'} size={iconSize} />;
    else if (icon === 'save') icon = <MaterialCommunityIcons name={'content-save'} size={iconSize} />;
    else if (icon === 'remove') {
      icon = <AntDesign name={'close'} size={iconSize} />;
      color = 'red';
    } else {
      icon = null;
    }
  }
  if (style?.backgroundColor === Colors.colorApp && color === Colors.colorApp) color = 'white';
  if (style?.backgroundColor === 'red') color = 'white';
  const newIcon = icon && React.cloneElement(icon, { color });
  return (
    <BaseButton
      disabled={disabled}
      style={{
        ...Styles.center,
        borderRadius: UIConst.SCALE * 6,
        paddingHorizontal: UIConst.SCALE * 10,
        paddingVertical: UIConst.SCALE * 6,
        marginHorizontal: UIConst.SCALE * 4,
        flexDirection: 'row',
        borderWidth: UIConst.SCALE * 0.8,
        borderColor: color,
        opacity: disabled ? 0.7 : 1,
        ...style
      }}
      onPress={onPress || onClick}>
      {newIcon}
      {!!text && (
        <BaseText numberOfLines={1} adjustsFontSizeToFit {...textProps} style={{ marginLeft: icon ? UIConst.SCALE * 3 : 0, color, ...textStyle }}>
          {text}
        </BaseText>
      )}
      {children}
    </BaseButton>
  );
};
